import {wupoServerUri} from '../Api';

const getAllUsers = async(jwtToken) => {
  
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/allUsersInfo`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const product = await response.json();
    console.log(product);

    return product;
  }

  else {
    return null;
  }
}

const getAllClientUsers = async(jwtToken) => {
  
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/allClientUsersInfo`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const product = await response.json();
    console.log(product);

    return product;
  }

  else {
    return null;
  }
}

const getAllAdvisorUsers = async(jwtToken) => {
  
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/allAdvisorUsersInfo`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
  })
  .catch((error) => {
    console.log("Error: " + error);
  });

  console.log(response.status);
  if(response.status === 200 ){
    const product = await response.json();
    console.log(product);

    return product;
  }

  else {
    return null;
  }
}



const getReportTraceSummaries = async (jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/report-traces`, {
    method: "GET",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const getReportTrace = async (reportId, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/report-traces/${reportId}`, {
    method: "GET",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const previewTableInjection = async (file, tableName, description, jwtToken) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("tableName", tableName);
  if (description) formData.append("description", description);

  const response = await fetch(`${wupoServerUri.devnet}/api/admin/tableinjection/preview`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
    },
    body: formData,
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return { ok: true, data: await response.json() };
  }
  if (response) {
    let errBody = null;
    try { errBody = await response.json(); } catch (_) { /* ignore */ }
    return { ok: false, status: response.status, error: errBody && errBody.error ? errBody.error : `Request failed (${response.status})` };
  }
  return { ok: false, error: "Network error" };
};

// Kicks off an async commit. Returns the initial job ({ jobId, status:"RUNNING", ... }).
// The backend responds 202 Accepted immediately; the actual Delta create + bulk
// insert run in the background. Poll getCommitJobStatus(jobId) until terminal.
const commitTableInjection = async (commitRequest, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/tableinjection/commit`, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(commitRequest),
  }).catch((error) => {
    console.log("Error: " + error);
  });

  // Accept any 2xx — the commit endpoint returns 202 Accepted (async), and we
  // don't want the success path to be brittle to the exact status code.
  if (response && response.ok) {
    return { ok: true, data: await response.json() };
  }
  if (response) {
    let errBody = null;
    try { errBody = await response.json(); } catch (_) { /* ignore */ }
    return { ok: false, status: response.status, error: errBody && errBody.error ? errBody.error : `Request failed (${response.status})` };
  }
  return { ok: false, error: "Network error" };
};

const getCommitJobStatus = async (jobId, jwtToken) => {
  const response = await fetch(
    `${wupoServerUri.devnet}/api/admin/tableinjection/commit-status/${encodeURIComponent(jobId)}`,
    {
      method: "GET",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
    },
  ).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return { ok: true, data: await response.json() };
  }
  if (response) {
    let errBody = null;
    try { errBody = await response.json(); } catch (_) { /* ignore */ }
    return { ok: false, status: response.status, error: errBody && errBody.error ? errBody.error : `Request failed (${response.status})` };
  }
  return { ok: false, error: "Network error" };
};

const listInjectedTables = async (jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/tableinjection/list`, {
    method: "GET",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return await response.json();
  }
  return null;
};

const retireInjectedTable = async (tableName, jwtToken) => {
  const response = await fetch(`${wupoServerUri.devnet}/api/admin/tableinjection/${encodeURIComponent(tableName)}`, {
    method: "DELETE",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => {
    console.log("Error: " + error);
  });

  if (response && response.status === 200) {
    return { ok: true, data: await response.json() };
  }
  if (response) {
    let errBody = null;
    try { errBody = await response.json(); } catch (_) { /* ignore */ }
    return { ok: false, status: response.status, error: errBody && errBody.error ? errBody.error : `Request failed (${response.status})` };
  }
  return { ok: false, error: "Network error" };
};

const reviewBaseUrl = (stagingId) =>
  `${wupoServerUri.devnet}/api/admin/tableinjection/review/${encodeURIComponent(stagingId)}`;

const handleReviewResponse = async (response) => {
  if (response && response.status === 200) {
    return { ok: true, data: await response.json() };
  }
  if (response) {
    let errBody = null;
    try { errBody = await response.json(); } catch (_) { /* ignore */ }
    return {
      ok: false,
      status: response.status,
      error: errBody && errBody.error ? errBody.error : `Request failed (${response.status})`,
    };
  }
  return { ok: false, error: "Network error" };
};

const getReviewState = async (stagingId, jwtToken) => {
  const response = await fetch(reviewBaseUrl(stagingId), {
    method: "GET",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => { console.log("Error: " + error); });
  return handleReviewResponse(response);
};

const submitColumnKnowledge = async (stagingId, columnName, knowledge, jwtToken) => {
  const response = await fetch(
    `${reviewBaseUrl(stagingId)}/columns/${encodeURIComponent(columnName)}/knowledge`,
    {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({ knowledge }),
    },
  ).catch((error) => { console.log("Error: " + error); });
  return handleReviewResponse(response);
};

const acceptColumn = async (stagingId, columnName, jwtToken) => {
  const response = await fetch(
    `${reviewBaseUrl(stagingId)}/columns/${encodeURIComponent(columnName)}/accept`,
    {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
    },
  ).catch((error) => { console.log("Error: " + error); });
  return handleReviewResponse(response);
};

const overrideColumn = async (stagingId, columnName, overrideBody, jwtToken) => {
  const response = await fetch(
    `${reviewBaseUrl(stagingId)}/columns/${encodeURIComponent(columnName)}/override`,
    {
      method: "POST",
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(overrideBody),
    },
  ).catch((error) => { console.log("Error: " + error); });
  return handleReviewResponse(response);
};

const cancelReview = async (stagingId, jwtToken) => {
  const response = await fetch(reviewBaseUrl(stagingId), {
    method: "DELETE",
    credentials: 'include',
    headers: {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json; charset=UTF-8",
    },
  }).catch((error) => { console.log("Error: " + error); });
  return handleReviewResponse(response);
};

export{
  getAllAdvisorUsers,
  getAllClientUsers,
  getAllUsers,
  getReportTraceSummaries,
  getReportTrace,
  previewTableInjection,
  commitTableInjection,
  getCommitJobStatus,
  listInjectedTables,
  retireInjectedTable,
  getReviewState,
  submitColumnKnowledge,
  acceptColumn,
  overrideColumn,
  cancelReview,
};